import React from 'react';
import { Modal, Button, Text, Group } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import i18n from '../../assets/locales/i18n';

interface PeriodErrorModalProps {
  opened: boolean;
  close: any;
}

const PeriodErrorModal = ({ opened, close }: PeriodErrorModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      opened={opened}
      onClose={close}
      title="PeriodError"
      size="xs"
      centered={true}
    >
      <Text size="md" style={{ textAlign: 'center' }} my="md">
        <br />
        {t(`error.period`)}
      </Text>
      <Group justify="center">
        <Button onClick={close}>Confirm</Button>
      </Group>
    </Modal>
  );
};

export default PeriodErrorModal;
